import { CSSObject } from '@emotion/react';
import { useHoneycombTheme } from '../../theming';

type ButtonBaseStyleClasses = 'root';

export function useStyles(): {
    styles: { [key in ButtonBaseStyleClasses]: CSSObject };
} {
    const { theme } = useHoneycombTheme();

    const root: CSSObject = {
        position: 'relative',
        backgroundColor: 'transparent',
        outline: 0,
        border: 0,
        margin: 0,
        borderRadius: 0,
        padding: 0,
        cursor: 'pointer',
        userSelect: 'none',
        appearance: 'none',
        textDecoration: 'none',
        color: 'inherit',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        '&::-moz-focus-inner': {
            borderStyle: 'none',
        },
        '&[disabled], &[aria-disabled="true"]': {
            pointerEvents: 'none',
            opacity: `${theme.interaction.disabledOpacity}`,
        },
    };

    return {
        styles: {
            root,
        },
    };
}
